import { mutationOptions } from '@tanstack/react-query';

import { recordingApi } from './audio-recording.api';

export type StartRecordingCallbacks = {
    onError: () => void;
};

export function useStartRecordingOptions({ onError }: StartRecordingCallbacks) {
    return mutationOptions({
        mutationFn: (recordingId: string) => recordingApi.start(recordingId),
        onError,
    });
}
